import React from 'react';

export default class Component extends React.Component {
  // 必要なprops
  // okClickHandler    : OKボタンを押したときのfunction
  // okText            : OKボタンのラベルテキスト
  // okBtnClass        : OKボタンのクラス
  // closeModal        : キャンセルボタンを押したときのfunction
  // cancelText        : キャンセルボタンのラベルテキスト
  // cancelBtnClass    : キャンセルボタンのクラス
  // noIcon            : アイコンの有無{boolean}
  // isOpen            : モーダルを開くかどうか{boolean}
  // headerTitle       : モーダル見出しの文章
  // children          : モーダル本文

  closeModal = () => {
    const dialog = document.querySelector('.dialog.active')
    dialog.classList.remove('fadein')
    dialog.classList.add('fadeout')
    setTimeout(() => {
      this.props.closeModal()
    }, 1000);
  }


  componentDidMount = () => {
    const dialogBack = document.querySelector('.dialog')
    const close = (e) => {
      const dialog = document.querySelector('.dialog-container')
      if (e && dialog.contains(e.target)) {
        return
      }
      this.closeModal()
    }
    dialogBack.addEventListener('click',close)
  }

  render = () => {
    let okBtn
    if (this.props.okClickHandler === null) {
      okBtn = null
    } else {
      okBtn = (
        <span className={this.props.okBtnClass || 'btn btn-danger btn-block'} onClick={this.props.okClickHandler}>{this.props.okText || 'OK'}</span>
      )
    }
    return (
      <div className={'dialog ' + (this.props.isOpen ? 'active fadein' : '')}>
        <div className='dialog-wrapper'>
          <div className='dialog-container container'>
            <div className='dialog-header'>{this.props.headerTitle || '確認'}</div>
            <div className='dialog-body row'>
              <div className='col-12'>
                {(() => {
                  if (!this.props.noIcon) {
                    return (
                      <p className='alert-icon'>
                        <i className="material-icons">report_problem</i>
                      </p>
                    )
                  }
                })()}
                {this.props.children}
              </div>
              <div className={ okBtn === null ? 'col-12' : 'col-6' }>
                <span className={this.props.cancelBtnClass || 'btn btn-white btn-block'} onClick={this.closeModal}>{this.props.cancelText || 'キャンセル'}</span>
              </div>
              <div className='col-6'>
                {okBtn}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/App/Modal.jsx